import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { TeltonikaCheckInPayload, TeltonikaErrorLog, TeltonikaLog, TeltonikaLogTableData, TeltonikaCheckInData } from '@huge-monorepo/shared/interfaces'
import { ActivatedRoute } from '@angular/router';
import { MaterialModule } from '@huge-monorepo/shared/modules';
import { TeltonikaDisplayLogsModalComponent } from '../../modals/teltonika-display-logs-modal/TeltonikaDisplayLogsModal.component';
import { MatDialog } from '@angular/material/dialog';
import { DialogService } from '@huge-monorepo/shared/services';
import { forkJoin, Observable, lastValueFrom } from 'rxjs';
import { SharedTeltonikaSingletonService } from '@huge-monorepo/shared/services';
import { IHIPTeltonikaService, ICustomerTeltonikaService } from '@huge-monorepo/shared/interfaces';

@Component({
  selector: 'huge-monorepo-teltonika-device-general',
  standalone: true,
  imports: [CommonModule, MatIconModule, MaterialModule],
  templateUrl: './teltonika-device-general.component.html',
  styleUrl: './teltonika-device-general.component.scss',
})
export class TeltonikaDeviceGeneralComponent implements OnInit {
  teltonikaService = this.sharedTeltonikaService.getService();
  loading: boolean = false;
  recentDeviceEventsActionTypes: string[] = ["Delete Tag", "Reboot Device", "Update Tag", "Create Tag", "Update Device Tag", "Update Teltonika Custom Name", "Remote Access"];
  RecentDeviceEventsData?: TeltonikaLogTableData;
  RecentDeviceFilesData?: TeltonikaLogTableData;
  recentDeviceFilesActionTypes: string[] = ["Generate TS File", "Generate Backup File", "Upload Config"];
  RecentTaskManagerLogsData?: TeltonikaLogTableData;
  ConfigurationLogsData?: TeltonikaLogTableData;
  ErrorLogsData?: TeltonikaLogTableData;
  CheckInData?: TeltonikaLogTableData;


  dataTables: TeltonikaLogTableData[] = [];

  id: number;

  constructor(
    private sharedTeltonikaService: SharedTeltonikaSingletonService<ICustomerTeltonikaService | IHIPTeltonikaService>,
    private activatedRoute: ActivatedRoute,
    private dialog: MatDialog,
    private dialogService: DialogService
  ) { }

  ngOnInit(): void {
    this.loading = true;
    this.activatedRoute.paramMap.subscribe(
      (paraMap: any) => {
        if (paraMap.params.id) {
          this.id = paraMap.params.id;
          this.initData(this.id);
        }
      }
    );
  }

  initData(id: number): void {
    this.loading = true;

    Promise.all([
      lastValueFrom(this.teltonikaService.getDeviceLogs(id, this.recentDeviceEventsActionTypes, 5, true)) as Promise<TeltonikaLog[]>,
      lastValueFrom(this.teltonikaService.getDeviceLogs(id, this.recentDeviceFilesActionTypes)) as Promise<TeltonikaLog[]>,
      lastValueFrom(this.teltonikaService.getDeviceErrorLogs(id, 5)) as Promise<TeltonikaErrorLog[]>,
      lastValueFrom(this.teltonikaService.getDeviceCheckInPayloads(id)) as Promise<TeltonikaCheckInPayload>
    ])
      .then(([recentDeviceEvents, recentDeviceFiles, errorLogs, checkIns]) => {
        // forkJoin([
        //   this.teltonikaService.getDeviceLogs(id, this.recentDeviceEventsActionTypes, 5, true),
        //   this.teltonikaService.getDeviceLogs(id, this.recentDeviceFilesActionTypes),
        //   this.teltonikaService.getDeviceErrorLogs(id, 5),
        //   this.teltonikaService.getDeviceCheckInPayloads(id)
        // ]).subscribe({
        //   next: ([recentDeviceEvents, recentDeviceFiles, errorLogs, checkIns]) => {
        this.deviceEventsDataHandling(recentDeviceEvents);
        this.deviceFilesDataHandling(recentDeviceFiles);
        this.errorLogsDataHandling(errorLogs);
        this.checkInDataHandling(checkIns);

        this.updateAndSortDataTables();
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  updateAndSortDataTables(): void {
    // Ensure all necessary updates are performed before sorting
    const orderFn = (a: TeltonikaLogTableData, b: TeltonikaLogTableData) => {
      const order = ["Recent Device Events", "Recent Device Files", "Latest Check Ins", "Error Logs"];
      const indexA = order.indexOf(a.heading);
      const indexB = order.indexOf(b.heading);
      if (indexA !== -1 && indexB !== -1) {
        return indexA - indexB;
      }
      return indexA === -1 ? 1 : indexB === -1 ? -1 : 0;
    };
    this.dataTables.sort(orderFn);
    this.loading = false;
  }

  displayFullTable(request: Observable<any> | null, tableConfig: TeltonikaLogTableData): void {
    const dialogRef = this.dialog.open(TeltonikaDisplayLogsModalComponent, {
      width: '90vw',
      maxHeight: '80vh',
      data: { dataRequest: request, tableConfig: tableConfig }
    });
    this.dialogService.RegisterDialog(dialogRef);
  }


  isString(value): value is string {
    return typeof value === 'string';
  }

  determineSplitting(): string {
    if ((this.RecentDeviceEventsData != null && this.RecentDeviceFilesData != null) && (this.RecentTaskManagerLogsData == null || this.ConfigurationLogsData == null)) {
      return 'top-split';
    }
    if ((this.RecentDeviceEventsData == null || this.RecentDeviceFilesData == null) && (this.RecentTaskManagerLogsData != null && this.ConfigurationLogsData != null)) {
      return 'bottom-split';
    }
    if ((this.RecentDeviceEventsData != null && this.RecentDeviceFilesData != null) && (this.RecentTaskManagerLogsData != null && this.ConfigurationLogsData != null)) {
      return 'all-split';
    }
    return 'no-split';


  }

  deviceEventsDataHandling(recentDeviceEvents: TeltonikaLog[]) {
    if (recentDeviceEvents == null) {
      return;
    }

    const fullScreenTableData: TeltonikaLogTableData = {
      heading: "Recent Device Events",
      columns: [{ header: "Log", rowKey: "Description", onClick: (data: string) => fullScreenTableData.overwriteText = data, styles: { clickable: 'white-space: nowrap; overflow:hidden; text-overflow:ellipsis; max-width:400px;' } },
      { header: "User", rowKey: "User" },
      { header: "Type", rowKey: "Type" },
      { header: "Date", rowKey: "Timestamp" }],
      loading: false,
    };

    const refreshFunction: () => void = () => {
      if (this.RecentDeviceEventsData) {
        // this.RecentDeviceEventsData.loading = true;

        //   const recentData = this.RecentDeviceEventsData; // Stores a reference to the same object

        //   this.teltonikaService.getDeviceLogs(this.id, this.recentDeviceEventsActionTypes).subscribe({
        //     next: (data) => {
        //       recentData.rows = data;  // Updates the same object
        //       recentData.loading = false; // Updates the same object
        //     }
        //   });
        // }
        this.RecentDeviceEventsData.loading = true;
        const recentData = this.RecentDeviceEventsData;
        this.teltonikaService.getDeviceLogs(this.id, this.recentDeviceEventsActionTypes, 5, true).subscribe({
          next: (data) => {
            recentData.rows = data;
            recentData.loading = false;
          }
        });
      }
      return;
    };

    this.RecentDeviceEventsData = {
      heading: "Recent Device Events",
      columns: [{ header: "Log", rowKey: "Description", styles: { unclickable: 'white-space: nowrap; overflow:hidden; text-overflow:ellipsis; width:70%; max-width:0px;' }, class: "ellipsis-text" }, { header: "User", rowKey: "User" }, { header: "Type", rowKey: "Type" }, { header: "Date", rowKey: "Timestamp" }],
      rows: recentDeviceEvents,
      buttons: [{
        action: () => {
          this.disableRefreshTemporarily("Recent Device Events", refreshFunction)
          refreshFunction();
        },
        icon: "refresh"
      },
      { action: () => this.displayFullTable(this.teltonikaService.getDeviceLogs(this.id, this.recentDeviceEventsActionTypes, 500, true), fullScreenTableData), icon: "fullscreen" }],
      loading: false,
    };

    this.dataTables.push(this.RecentDeviceEventsData);

  }

  deviceFilesDataHandling(recentDeviceFiles: TeltonikaLog[]) {
    if (recentDeviceFiles == null) {
      return;
    }

    const fullScreenTableData: TeltonikaLogTableData = {
      heading: "Recent Device Files",
      columns: [{ header: "Log", rowKey: "Description", onClick: (data: string) => fullScreenTableData.overwriteText = data, styles: { clickable: 'white-space: nowrap; overflow:hidden; text-overflow:ellipsis; max-width:400px;' } },
      { header: "User", rowKey: "User" },
      { header: "Type", rowKey: "Type" },
      { header: "Date", rowKey: "Timestamp" }],
      loading: false,
    };

    const refreshFunction: () => void = () => {
      if (this.RecentDeviceFilesData) {
        this.RecentDeviceFilesData.loading = true;

        const recentData = this.RecentDeviceFilesData; // Store reference

        this.teltonikaService.getDeviceLogs(this.id, this.recentDeviceFilesActionTypes).subscribe({
          next: (data) => {
            recentData.rows = data;  // Updates the same object
            recentData.loading = false;
          }
        });
      }
    };

    this.RecentDeviceFilesData = {
      heading: "Recent Device Files",
      columns: [{ header: "Log", rowKey: "Description", styles: { unclickable: 'white-space: nowrap; overflow:hidden; text-overflow:ellipsis; width:70%; max-width:0px;' }, class: "ellipsis-text" }, { header: "User", rowKey: "User" }, { header: "Type", rowKey: "Type" }, { header: "Date", rowKey: "Timestamp" }],
      rows: recentDeviceFiles,
      buttons: [{
        action: () => {
          this.disableRefreshTemporarily("Recent Device Files", refreshFunction)
          refreshFunction();
        },
        icon: "refresh"
      },
      { action: () => this.displayFullTable(this.teltonikaService.getDeviceLogs(this.id, this.recentDeviceFilesActionTypes, 500), fullScreenTableData), icon: "fullscreen" }],
      loading: false,
    };

    this.dataTables.push(this.RecentDeviceFilesData);

  }

  errorLogsDataHandling(errorLogs: TeltonikaErrorLog[]) {
    if (errorLogs == null) {
      return;
    }

    const fullScreenTableData: TeltonikaLogTableData = {
      heading: "Error Logs",
      columns: [{ header: "User", rowKey: "User" },
      { header: "Error Message", rowKey: "FullError", onClick: (data: string) => fullScreenTableData.overwriteText = data, styles: { clickable: 'white-space: nowrap; overflow:hidden; text-overflow:ellipsis; max-width:400px;' }, class: "ellipsis-text" },
      { header: "Date", rowKey: "Timestamp" }],
      loading: false,
    };

    const refreshFunction: () => void = () => {
      if (this.ErrorLogsData) {
        this.ErrorLogsData.loading = true;

        const errorLogsData = this.ErrorLogsData; // Store reference

        this.teltonikaService.getDeviceErrorLogs(this.id, 5).subscribe({
          next: (errorLogs) => {
            errorLogsData.rows = errorLogs;  // Updates the same object
            errorLogsData.loading = false;
          }
        });
      }
    };

    this.ErrorLogsData = {
      heading: "Error Logs",
      columns: [{ header: "User", rowKey: "User" }, { header: "Error Message", rowKey: "FullError", styles: { unclickable: 'white-space: nowrap; overflow:hidden; text-overflow:ellipsis; width:70%; max-width:0px;' }, class: "ellipsis-text" }, { header: "Date", rowKey: "Timestamp" }],
      rows: errorLogs,
      buttons: [{
        action: () => {
          this.disableRefreshTemporarily("Error Logs", refreshFunction)
          refreshFunction();
        },
        icon: "refresh"
      },
      { action: () => this.displayFullTable(this.teltonikaService.getDeviceErrorLogs(this.id, 500), fullScreenTableData), icon: "fullscreen" }],
      loading: false,
    };

    this.dataTables.push(this.ErrorLogsData);

  }

  checkInDataHandling(checkIns: TeltonikaCheckInPayload) {
    if (checkIns == null) {
      return;
    }

    let formattedData: TeltonikaCheckInData[] = [];

    if (checkIns.StandardCheckInPayload != null) {
      formattedData.push({
        Type: "Standard",
        Payload: checkIns.StandardCheckInPayload,
        Timestamp: checkIns.StandardCheckInTimestamp
      })
    }

    if (formattedData.length == 0) {
      return;
    }

    const fullScreenTableData: TeltonikaLogTableData = {
      heading: "Latest Check Ins",
      columns: [{ header: "Check In Type", rowKey: "Type" },
      { header: "Payload", rowKey: "Payload", onClick: (data: string) => fullScreenTableData.overwriteText = data, styles: { clickable: 'white-space: nowrap; overflow:hidden; text-overflow:ellipsis; max-width:400px;' } },
      { header: "Date", rowKey: "Timestamp" }],
      rows: formattedData,
      loading: false,
    }

    const refreshFunction: () => void = () => {
      if (!this.CheckInData) return; // Ensure it's defined before using it

      this.CheckInData.loading = true;

      this.teltonikaService.getDeviceCheckInPayloads(this.id).subscribe({
        next: (data) => {
          let formattedData: TeltonikaCheckInData[] = [];

          if (!data && this.CheckInData) {
            this.CheckInData.rows = formattedData;
            this.CheckInData.loading = false;
            return;
          }

          if (data.StandardCheckInPayload) {
            formattedData.push({
              Type: "Standard",
              Payload: data.StandardCheckInPayload,
              Timestamp: data.StandardCheckInTimestamp
            });
          }

          if (this.CheckInData) {
            this.CheckInData.rows = formattedData;
            this.CheckInData.loading = false;
          }
        }
      });
    };

    this.CheckInData = {
      heading: "Latest Check Ins",
      columns: [{ header: "Check In Type", rowKey: "Type" },
      { header: "Payload", rowKey: "Payload", styles: { unclickable: 'white-space: nowrap; overflow:hidden; text-overflow:ellipsis; width:70%; max-width:0px;' }, class: "ellipsis-text" },
      { header: "Date", rowKey: "Timestamp" }],
      rows: formattedData,
      buttons: [{
        action: () => {
          this.disableRefreshTemporarily("Latest Check Ins", refreshFunction)
          refreshFunction();
        },
        icon: "refresh"
      },
      { action: () => this.displayFullTable(null, fullScreenTableData), icon: "fullscreen" }],
      loading: false,
    };

    this.dataTables.push(this.CheckInData);


  }

  /**
   * Temporarily removes the refresh button and restores it after a timeout to prevent user from constantly refreshing.
   * 
   * @param {string} tableKey - The heading of the table to modify.
   * @param {() => void} refreshTableData - The function that refreshes table data.
   */
  disableRefreshTemporarily(tableKey: string, refreshTableData: () => void) {
    const table = this.dataTables.find(t => t.heading === tableKey);
    if (!table || !table.buttons) return;  // Ensure table and table.buttons exist

    table.buttons = table.buttons.filter(btn => btn.icon !== "refresh");

    setTimeout(() => {
      if (table.buttons) {
        table.buttons.unshift({
          action: () => {
            this.disableRefreshTemporarily(tableKey, refreshTableData);
            refreshTableData();
          },
          icon: "refresh"
        });
      }
    }, 10000);
  }
}